/* ============================================================
   S&T pre-sale pricing cards — BENEFITS +/− accordion.
   Shared by global_membership, global_credits and
   global_monthly-credits (any [data-benefits-toggle] inside
   a .card-benefits wrapper).
   ============================================================ */
(function () {
  'use strict';
  if (window.stMembershipLoaded) return;
  window.stMembershipLoaded = true;

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-benefits-toggle]') : null;
    if (!toggle) return;

    var wrap = toggle.closest('.card-benefits');
    if (!wrap) return;

    var open = wrap.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();